export default "__VITE_ASSET__DLW95EQe__"